<!--
 * @Description: 
 * @Date: 2021-07-29 11:12:45
-->
<template>
  <div class="group">
    <div class="item">
      <div class="name"></div>
      <el-radio
        :disabled="disabled"
        v-model="queryData.isMail"
        :label="1"
        style="margin-left:10px;font-weight:800;"
      >
        邮寄
      </el-radio>
      <el-radio
        :disabled="disabled"
        v-model="queryData.isMail"
        :label="0"
        style="font-weight:800;"
      >
        非邮寄
      </el-radio>
    </div>
    <div class="item wuliu-box" v-if="queryData.isMail == 1">
      <div class="name"></div>
      <div class="wuliu">
        <el-form-item class="item" prop="companyName">
          <div class="name">公司名称：</div>
          <dic-select
            :defaultActive="
              queryData.companyName
                ? {
                    companyName: queryData.companyName,
                    companyCode: queryData.companyCode
                  }
                : {}
            "
            :isDisabled="disabled"
            class="val"
            @dic-select-obj="saveCompany"
            :fuzzyDef="searchAjaxPro"
            :prop="{
              label: 'companyName',
              code: 'companyCode'
            }"
            :assginParams="{}"
            ajaxQuery="title"
            placeholder="请选择快递公司"
          />
        </el-form-item>
        <el-form-item class="item" prop="trackingNo">
          <div class="name">快递单号：</div>
          <el-input
            class="val"
            :disabled="disabled"
            v-model="queryData.trackingNo"
            placeholder="请填写快递单号"
          ></el-input>
        </el-form-item>
      </div>
    </div>
  </div>
</template>
<script>
import { invoiceNew } from '@/api/ajax';
import dicSelect from '@/components/Common/dicSelect';
export default {
  components: { dicSelect },
  props: {
    disabled: [Boolean],
    info: {
      type: Object,
      default: () => {
        return {
          trackingNo: '',
          companyCode: '',
          companyName: '',
          isMail: 0
        };
      }
    }
  },
  data() {
    return {
      queryData: {
        trackingNo: '',
        companyCode: '',
        companyName: '',
        isMail: 0
      },
      searchAjaxPro: invoiceNew.queryLogisticsCompany
    };
  },
  methods: {
    saveCompany(v) {
      this.queryData.companyCode = v.companyCode || 0;
      this.queryData.companyName = v.companyName || '';
    },
    cancel() {
      this.$emit('close');
    }
  },
  created() {
    this.queryData = { ...this.info };
  },
  watch: {
    queryData: {
      handler(newV) {
        this.$emit('change', newV);
      },
      deep: true
    }
  }
};
</script>
<style lang="scss" scoped>
.wuliu {
  display: flex;
  & > div {
    width: 250px;
    margin-bottom: 25px;
    margin-right: 25px;
  }
}
</style>
